(function () {
  var debounceTimer;
  // Custom event to trigger price update
  function getWidgetBlock(widget) {
    return widget.closest('.shopify-app-block') || widget.closest('.shopify-block');
  }
  // Get block settings
  function getBlockSettings(widget) {
    var block = getWidgetBlock(widget);
    if (!block) return {};
    var script = block.querySelector('script[data-bsub-block-settings-json]') ||
      block.querySelector('[data-bsub-block-settings-json]');
    if (!script) return {};
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return {};
    }
  }
  // Get header text
  function getHeaderText(widget) {
    var settings = getBlockSettings(widget);
    if (settings.header_text) {
      return settings.header_text.trim();
    }
    var legend = widget.querySelector(':scope > legend');
    if (legend && legend.textContent.trim()) {
      return legend.textContent.trim();
    }
    return 'Frequency:';
  }
  // Get discount suffix
  function getDiscountSuffix(widget) {
    var summary = widget.querySelector('[data-bsub-group-discount-summary]');
    if (summary && summary.textContent.trim()) {
      return ' ' + summary.textContent.trim();
    }
    var settings = getBlockSettings(widget);
    var template = settings.delivery_frequency_discount_text || '({discount} off)';
    return ' ' + template.replace('{discount}', '10%');
  }
  function getCurrentVariant() {
    var productScript = document.querySelector('.product-json');
    var form = document.getElementById('add-to-cart-form');
    if (!productScript || !form) return null;

    try {
      var product = JSON.parse(productScript.textContent);
      var idInput = form.querySelector('[name="id"]');
      var variantId = idInput ? parseInt(idInput.value, 10) : null;
      if (!variantId || !product.variants) return null;
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].id === variantId) return product.variants[i];
      }
    } catch (e) {
      return null;
    }
    return null;
  }

  function getMoneyFormat() {
    var global = document.getElementById('wetheme-global');
    if (!global) return '${{amount}}';
    try {
      return JSON.parse(global.textContent).moneyFormat || '${{amount}}';
    } catch (e) {
      return '${{amount}}';
    }
  }

  function formatMoney(cents) {
    var format = getMoneyFormat();
    var amount = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function normalizePlanId(value) {
    if (value == null || value === '') return '';
    var str = String(value);
    var gidMatch = str.match(/SellingPlan\/(\d+)/i);
    return gidMatch ? gidMatch[1] : str;
  }

  function getAllocationCents(allocation) {
    if (!allocation) return null;
    return allocation.per_delivery_price != null ? allocation.per_delivery_price : allocation.price;
  }

  function getSellingPlanAllocationPrice(variant, sellingPlanId, widget) {
    if (!variant || !variant.selling_plan_allocations || !variant.selling_plan_allocations.length) {
      return null;
    }

    var targetId = normalizePlanId(sellingPlanId);

    for (var i = 0; i < variant.selling_plan_allocations.length; i++) {
      var allocation = variant.selling_plan_allocations[i];
      var planId = normalizePlanId(
        allocation.selling_plan_id || (allocation.selling_plan && allocation.selling_plan.id)
      );
      if (planId && targetId && planId === targetId) {
        return getAllocationCents(allocation);
      }
    }

    if (widget) {
      var checked = widget.querySelector('input[data-bsub-delivery-frequency-option]:checked');
      if (checked) {
        var radios = widget.querySelectorAll('input[data-bsub-delivery-frequency-option]');
        var idx = Array.prototype.indexOf.call(radios, checked);
        if (idx >= 0 && variant.selling_plan_allocations[idx]) {
          return getAllocationCents(variant.selling_plan_allocations[idx]);
        }
      }
    }

    if (variant.selling_plan_allocations.length === 1) {
      return getAllocationCents(variant.selling_plan_allocations[0]);
    }

    return null;
  }

  function isOneTimeSelected(widget) {
    widget = widget || document.querySelector('.bsub-widget');
    return !!(widget && widget.querySelector('[data-bsub-purchase-option-one-time]:checked'));
  }

  function getSubscribePriceCents(widget) {
    widget = widget || document.querySelector('.bsub-widget');
    if (!widget) return null;

    var checked = widget.querySelector('input[data-bsub-delivery-frequency-option]:checked');
    if (!checked) return null;

    var variant = getCurrentVariant();
    var allocationPrice = getSellingPlanAllocationPrice(variant, checked.value, widget);
    if (allocationPrice != null) return allocationPrice;

    var container = checked.closest('.bsub-option-container');
    var priceEl = container ? container.querySelector('[data-bsub-per-delivery-price]') : null;
    if (priceEl && priceEl.textContent.trim()) {
      var cleaned = priceEl.textContent.trim().replace(/[^\d.,]/g, '');
      var amount = parseFloat(cleaned.replace(',', '.'));
      if (!isNaN(amount)) return Math.round(amount * 100);
    }

    return null;
  }

  function getActiveUnitPriceCents() {
    var widget = document.querySelector('.bsub-widget');
    var variant = getCurrentVariant();

    if (widget && !isOneTimeSelected(widget)) {
      var subscribeCents = getSubscribePriceCents(widget);
      if (subscribeCents != null) return subscribeCents;
    }

    if (variant && variant.price) return variant.price;

    var priceField = document.getElementById('price-field');
    if (priceField && priceField.textContent.trim()) {
      var text = priceField.textContent.trim().replace(/[^\d.,]/g, '');
      var parsed = parseFloat(text.replace(',', '.'));
      if (!isNaN(parsed)) return Math.round(parsed * 100);
    }

    return 0;
  }

  // Get one-time price
  function getOneTimePrice() {
    var variant = getCurrentVariant();
    if (variant && variant.price) {
      return formatMoney(variant.price);
    }

    var moneyEl = document.querySelector('.product-page--pricing--variant-price .money');
    if (moneyEl && moneyEl.textContent.trim()) {
      return moneyEl.textContent.trim();
    }

    var priceField = document.getElementById('price-field');
    return priceField ? priceField.textContent.trim() : '';
  }
  // Get subscribe price
  function getSubscribePrice(widget) {
    var checked = widget.querySelector('input[data-bsub-delivery-frequency-option]:checked');
    if (!checked) return '';

    var variant = getCurrentVariant();
    var allocationPrice = getSellingPlanAllocationPrice(variant, checked.value, widget);
    if (allocationPrice != null) {
      return formatMoney(allocationPrice);
    }

    var container = checked.closest('.bsub-option-container');
    var priceEl = container ? container.querySelector('[data-bsub-per-delivery-price]') : null;
    if (priceEl && priceEl.textContent.trim()) {
      return priceEl.textContent.trim();
    }
    return '';
  }
  // Get active label (one-time or subscribe)
  function getActiveLabel(widget) {
    var settings = getBlockSettings(widget);
    var checked = widget.querySelector('[data-bsub-selling-plan-group-input]:checked');

    if (!checked || checked.value === 'once') {
      if (settings.one_time_text) return settings.one_time_text.trim();
      var oneTimeInput = widget.querySelector('[data-bsub-purchase-option-one-time]');
      var oneTimeGroup = oneTimeInput ? oneTimeInput.closest('.bsub-widget__group') : null;
      var oneTimeLabel = oneTimeGroup ? oneTimeGroup.querySelector('.bsub-widget__text') : null;
      return oneTimeLabel ? oneTimeLabel.textContent.trim() : 'One Time purchase';
    }

    if (settings.recurring_text) return settings.recurring_text.trim();
    var subscribeText = widget.querySelector('[data-bsub-selling-plan-group] .bsub-widget__text > span');
    return subscribeText ? subscribeText.textContent.trim() : 'Subscribe and Save';
  }
  // Ensure title is displayed
  function ensureTitle(widget) {
    var wrapper = widget.querySelector('.bsub-widget__wrapper');
    if (!wrapper) return;

    var title = wrapper.querySelector('.bsub-frequency-title');
    if (!title) {
      title = document.createElement('div');
      title.className = 'bsub-frequency-title';
      wrapper.insertBefore(title, wrapper.firstChild);
    }

    var headerText = getHeaderText(widget);
    var html = headerText + ' <strong>' + getActiveLabel(widget) + '</strong>';
    if (title.innerHTML !== html) {
      title.innerHTML = html;
    }
  }

  // Inject group prices
  function injectGroupPrices(widget) {
    var oneTimeInput = widget.querySelector('[data-bsub-purchase-option-one-time]');
    var oneTimeGroup = oneTimeInput ? oneTimeInput.closest('.bsub-widget__group') : null;
    var subscribeGroup = widget.querySelector('[data-bsub-selling-plan-group]');

    [oneTimeGroup, subscribeGroup].forEach(function (group, index) {
      if (!group) return;
      var header = group.querySelector('.bsub-widget__group-header');
      if (!header) return;
      var priceEl = header.querySelector('.bsub-widget__group-price');
      if (!priceEl) {
        priceEl = document.createElement('span');
        priceEl.className = 'bsub-widget__group-price';
        header.appendChild(priceEl);
      }
      var price = index === 0 ? getOneTimePrice() : getSubscribePrice(widget);
      if (priceEl.textContent !== price) {
        priceEl.textContent = price;
      }
    });
  }

  // Update active state
  function updateActiveState(widget) {
    var subscribeGroup = widget.querySelector('[data-bsub-selling-plan-group]');
    if (!subscribeGroup) return;
    var subscribeChecked = subscribeGroup.querySelector('[data-bsub-selling-plan-group-input]:checked');
    var isActive = !!subscribeChecked;
    var hasActive = subscribeGroup.classList.contains('bsub-widget__group--active');
    if (hasActive !== isActive) {
      subscribeGroup.classList.toggle('bsub-widget__group--active', isActive);
    }
  }

  // Move options to subscribe group
  function moveOptionsToSubscribeGroup(widget) {
    var subscribeGroup = widget.querySelector('[data-bsub-selling-plan-group]');
    var optionsContainer = widget.querySelector('.bsub-options-container');
    if (!subscribeGroup || !optionsContainer) return;
    subscribeGroup.classList.add('bsub-widget__group--subscribe');
    if (!subscribeGroup.contains(optionsContainer)) {
      subscribeGroup.appendChild(optionsContainer);
    }
  }

  // Create frequency dropdown
  function createFrequencyDropdown(widget) {
    var fieldset = widget.querySelector('.bsub-widget__delivery-fieldset');
    if (!fieldset) return false;

    var radios = fieldset.querySelectorAll('input[data-bsub-delivery-frequency-option]');
    if (!radios.length) return false;

    var discountSuffix = getDiscountSuffix(widget);
    var wrap = fieldset.querySelector('.bsub-frequency-dropdown-wrap');
    var select;

    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'bsub-frequency-dropdown-wrap';
      select = document.createElement('select');
      select.className = 'bsub-frequency-dropdown';
      select.setAttribute('aria-label', 'Delivery frequency');
      wrap.appendChild(select);
      fieldset.appendChild(wrap);

      select.addEventListener('change', function () {
        var radio = fieldset.querySelector('input[data-bsub-delivery-frequency-option][value="' + CSS.escape(select.value) + '"]');
        if (!radio) return;
        radio.checked = true;
        if (window.BOLD && window.BOLD.BsubWidget && window.BOLD.BsubWidget.handleSelectionChange) {
          window.BOLD.BsubWidget.handleSelectionChange({ target: radio });
        } else {
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        refreshWidget(widget);
      });
    } else {
      select = wrap.querySelector('.bsub-frequency-dropdown');
    }

    if (select && select.options.length === 0) {
      radios.forEach(function (radio) {
        var container = radio.closest('.bsub-option-container');
        var label = container ? container.querySelector('.bsub-widget__main-text') : null;
        var labelText = label ? label.textContent.trim() : radio.value;
        if (labelText.indexOf('off') === -1 && labelText.indexOf('%') === -1) {
          labelText += discountSuffix;
        }
        var option = document.createElement('option');
        option.value = radio.value;
        option.textContent = 'Delivery : ' + labelText;
        if (radio.checked) option.selected = true;
        select.appendChild(option);
      });
    }

    return true;
  }

  // Sync dropdown from radios
  function syncDropdownFromRadios(widget) {
    var select = widget.querySelector('.bsub-frequency-dropdown');
    var checked = widget.querySelector('input[data-bsub-delivery-frequency-option]:checked');
    if (select && checked && select.value !== checked.value) {
      select.value = checked.value;
    }
  }

  var priceNotifyTimer;

  function notifyPriceUpdate() {
    clearTimeout(priceNotifyTimer);
    priceNotifyTimer = setTimeout(function () {
      document.dispatchEvent(new CustomEvent('bsubWidgetUpdated'));
    }, 0);
  }

  // Refresh widget
  function refreshWidget(widget, skipNotify) {
    ensureTitle(widget);
    updateActiveState(widget);
    injectGroupPrices(widget);
    syncDropdownFromRadios(widget);
    if (!skipNotify) notifyPriceUpdate();
  }

  // Attach listeners
  function attachListeners(widget) {
    if (widget.dataset.figmaListeners === 'true') return;
    widget.dataset.figmaListeners = 'true';
    widget.addEventListener('change', function () {
      refreshWidget(widget);
    });
  }

  // Initialize widget
  function initWidget(widget, attempt) {
    attempt = attempt || 0;

    if (widget.dataset.bsubFigmaReady === 'true') {
      refreshWidget(widget);
      return;
    }

    if (!widget.querySelector('.bsub-widget__groups-container')) return;

    if (widget.classList.contains('bsub__hidden')) {
      if (attempt < 40) {
        setTimeout(function () { initWidget(widget, attempt + 1); }, 300);
      }
      return;
    }

    moveOptionsToSubscribeGroup(widget);

    var dropdownReady = createFrequencyDropdown(widget);
    if (!dropdownReady && attempt < 40) {
      setTimeout(function () { initWidget(widget, attempt + 1); }, 300);
      return;
    }

    refreshWidget(widget);
    attachListeners(widget);
    widget.dataset.bsubFigmaReady = 'true';
  }

  // Scan widgets
  function scanWidgets() {
    document.querySelectorAll('.bsub-widget').forEach(function (widget) {
      initWidget(widget, 0);
    });
  }

  // Debounced scan
  function debouncedScan() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(scanWidgets, 150);
  }

  function refreshAllWidgets() {
    var widgets = document.querySelectorAll('.bsub-widget');
    widgets.forEach(function (widget) {
      refreshWidget(widget, true);
    });
    if (widgets.length) notifyPriceUpdate();
  }

  var variantRefreshTimer;
  function scheduleVariantRefresh() {
    clearTimeout(variantRefreshTimer);
    [0, 100, 300, 600].forEach(function (delay) {
      setTimeout(refreshAllWidgets, delay);
    });
    variantRefreshTimer = setTimeout(refreshAllWidgets, 900);
  }

  function bindVariantOptionListeners() {
    var form = document.getElementById('add-to-cart-form');
    if (!form || form.dataset.berriPriceBound) return;
    form.dataset.berriPriceBound = 'true';

    form.querySelectorAll('.product-option-select select, .wetheme-dropdown__select').forEach(function (select) {
      select.addEventListener('change', scheduleVariantRefresh);
    });

    form.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') {
        scheduleVariantRefresh();
      }
    });
  }

  document.addEventListener('variantAvailable', scheduleVariantRefresh);
  document.addEventListener('variantUnavailable', scheduleVariantRefresh);

  window.BerriVariantPricing = {
    getCurrentVariant: getCurrentVariant,
    formatMoney: formatMoney,
    getOneTimePriceCents: function () {
      var variant = getCurrentVariant();
      return variant && variant.price ? variant.price : 0;
    },
    getSubscribePriceCents: getSubscribePriceCents,
    getActiveUnitPriceCents: getActiveUnitPriceCents,
    refreshPrices: scheduleVariantRefresh
  };

  function initPricing() {
    bindVariantOptionListeners();
    scanWidgets();
  }

  // Initialize widgets
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPricing);
  } else {
    initPricing();
  }

  // Only react when a new widget appears or Bold removes bsub__hidden — not every DOM tweak
  // Mutation observer
  var observer = new MutationObserver(function (mutations) {
    var needsScan = false;

    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];

      if (mutation.type === 'childList') {
        for (var j = 0; j < mutation.addedNodes.length; j++) {
          var node = mutation.addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.classList && node.classList.contains('bsub-widget')) {
            needsScan = true;
            break;
          }
          if (node.querySelector && node.querySelector('.bsub-widget')) {
            needsScan = true;
            break;
          }
        }
      }

      if (mutation.type === 'attributes' &&
          mutation.attributeName === 'class' &&
          mutation.target.classList &&
          mutation.target.classList.contains('bsub-widget') &&
          !mutation.target.classList.contains('bsub__hidden') &&
          mutation.target.dataset.bsubFigmaReady !== 'true') {
        needsScan = true;
      }

      if (needsScan) break;
    }

    if (needsScan) debouncedScan();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
})();
